/* ------------------------------------------------------------------
   Loox-Texte in der Seitensprache (26.10.2026)

   Loox hat KEINE Spracheinstellung (Lucius hat danach gesucht). Das
   Widget schreibt deshalb auch auf /de englisch. Drei Stellen kommen aus
   Loox' eigenem Markup und sind von aussen erreichbar:

     1. die Zahl in Klammern   "(1,290)"  -> "(1.290)"
     2. der Vorlesetext an den Sternen, im <title> des SVG:
        "1,290 reviews"  ->  "1.290 Bewertungen"
     3. die Titel der eingebetteten Bewertungs-Fenster (<iframe title>):
        "Reviews widget" / "Carousel cards reviews widget"

   Punkt 2 und 3 sind nicht sichtbar — sie sind das, was Screenreader
   vorlesen und was im Quelltext steht. Genau deshalb faellt es sonst
   niemandem auf.

   Die sichtbaren Texte INNERHALB des grossen Bewertungsblocks liegen in
   einem iframe von loox.io. Fremde Herkunft, kein Zugriff vom Dokument
   aus — das laesst sich von hier aus nicht aendern.

   Quelle der Zahl ist immer `data-raters` am Container (kommt aus dem
   Loox-Metafeld), nie Loox' gerenderter Text: nichts zu parsen, nichts
   zu raten. Die Woerter kommen aus den Locale-Dateien und werden in
   layout/theme.liquid als window.BL_LOOX_TEXTE uebergeben — kein
   sichtbarer Text im Skript (Projektregel 1).

   Faellt eines davon weg oder aendert Loox sein Markup, passiert
   schlicht nichts.
   ------------------------------------------------------------------ */
(function () {
  var T = window.BL_LOOX_TEXTE || {};
  var LAUF = null;

  function gebietsschema() {
    var l = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
    return l === 'en' ? 'en-US' : 'de-DE';
  }

  function zahl(n, loc) {
    try {
      return new Intl.NumberFormat(loc).format(n);
    } catch (e) {
      return null;
    }
  }

  function setzen(el, attribut, soll) {
    if (!el || !soll) return;
    if (attribut) {
      if (el.getAttribute(attribut) !== soll) el.setAttribute(attribut, soll);
    } else if (el.textContent.trim() !== soll) {
      /* Vergleich verhindert, dass der eigene Schreibvorgang den
         Beobachter unten endlos erneut ausloest. */
      el.textContent = soll;
    }
  }

  function uebersetzen() {
    var loc = gebietsschema();

    /* 1 + 2: Zahl in Klammern und Vorlesetext an den Sternen */
    var widgets = document.querySelectorAll('.loox-rating[data-raters]');
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      var n = parseInt(w.getAttribute('data-raters'), 10);
      if (!isFinite(n) || n <= 0) continue;
      var z = zahl(n, loc);
      if (z === null) continue;

      setzen(w.querySelector('.loox-rating-label'), null, '(' + z + ')');

      var wort = n === 1 ? T.bewertung_eine : T.bewertungen;
      if (wort) {
        var titel = w.querySelectorAll('title');
        for (var j = 0; j < titel.length; j++) setzen(titel[j], null, z + ' ' + wort);
      }
    }

    /* 3: Titel der eingebetteten Loox-Fenster.

       Erkannt wird ausschliesslich an der QUELL-ADRESSE, nicht am Titel:
       - Am Titel zu erkennen hiesse, fremde Fenster mitzunehmen. Die drei
         Trustpilot-Rahmen auf der Produktseite heissen auf Englisch von
         Haus aus "Reviews widget" — die gehoeren Trustpilot, nicht uns.
       - Und das Karussell am Wort "carousel" im Titel zu erkennen, waere
         ein Flattern: Nach dem ersten Lauf steht dort unser eigener Text,
         beim zweiten Lauf griffe die Erkennung nicht mehr und machte aus
         "Bewertungen (Karussell)" wieder "Bewertungen". Die Adresse
         aendert sich nicht. */
    var rahmen = document.querySelectorAll('iframe');
    for (var k = 0; k < rahmen.length; k++) {
      var r = rahmen[k];
      var quelle = r.getAttribute('src') || r.getAttribute('data-src') || '';
      if (quelle.indexOf('loox.io') === -1) continue;
      setzen(r, 'title', quelle.indexOf('carousel') !== -1 ? T.loox_widget_karussell : T.loox_widget);
    }
  }

  function anstossen() {
    clearTimeout(LAUF);
    LAUF = setTimeout(uebersetzen, 60);
  }

  function start() {
    uebersetzen();
    /* Loox laedt asynchron, und die Kollektionsfilter bauen die Karten
       neu auf — beides erzeugt die Texte spaeter noch einmal. */
    if (window.MutationObserver && document.body) {
      new MutationObserver(anstossen).observe(document.body, { childList: true, subtree: true });
    }
    /* Rueckfall, falls Loox Container und Text in einem Rutsch einsetzt
       und der Beobachter die fertige Stelle nicht mehr meldet. */
    var n = 0;
    var takt = setInterval(function () {
      uebersetzen();
      if (++n >= 12) clearInterval(takt);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
